<section class="nomination-container p-5 d-flex justify-content-center">
    <div class="d-flex h-100">
        <app-handler-back-and-breadcrumb-button class="back-button" [url]="chargesURL">
            BACK
        </app-handler-back-and-breadcrumb-button>
        <div class="d-flex flex-column mt-3 form-wrapper">
            <h1 class="mat-headline-5 mb-0">Request Nomination</h1>
            <h4 class="mat-subtitle-1 mb-5">Enter all fields below to proceed with your request.</h4>
            <form [formGroup]="nominationForm" (submit)="requestNomination()">
                <mat-form-field class="col-12">
                    <mat-label>1F Port Destination Firms Code</mat-label>
                    <input
                        matInput
                        placeholder="1F Port Destination Firms Code"
                        [imask]="alphaNumeric"
                        formControlName="firmsCode"
                    />
                    <mat-error>
                        <app-field-error [field]="'firmsCode'" [messageList]="formErrors['firmsCode']" />
                    </mat-error>
                </mat-form-field>
                <div class="col-12 mb-1 mat-mdc-form-field">
                    <ng-select
                        [items]="awbs"
                        bindLabel="name"
                        bindValue="name"
                        [addTag]="true"
                        placeholder="Select {{ paymentTypeDescription.toUpperCase() }} *"
                        formControlName="awb"
                        appearance="outline"
                        [multiple]="allowMultipleSelections"
                    />
                    <mat-error class="ng-select-error-container">
                        <app-field-error [field]="'awb'" [messageList]="formErrors['awb']" />
                    </mat-error>
                </div>
                <mat-form-field class="col-12">
                    <mat-label>Company name</mat-label>
                    <input matInput placeholder="Company name" formControlName="companyName" />
                    <mat-error>
                        <app-field-error [field]="'companyName'" [messageList]="formErrors['companyName']" />
                    </mat-error>
                </mat-form-field>
                <div class="col-12 mb-1 mat-mdc-form-field">
                    <ng-select
                        [addTag]="true"
                        placeholder="Email address(es) for confirmation"
                        formControlName="email"
                        appearance="outline"
                        [multiple]="allowMultipleSelections"
                    />
                    <mat-error class="ng-select-error-container">
                        <app-field-error [field]="'email'" [messageList]="formErrors['email']" />
                    </mat-error>
                </div>
                <div class="d-flex flex-row justify-content-end">
                    <button
                        matButton="outlined"
                        appMatStrokedButtonBorder
                        type="button"
                        color="primary"
                        (click)="onPressCancel()"
                        class="me-4"
                    >
                        CANCEL
                    </button>
                    <button
                        matButton="filled"
                        type="submit"
                        color="primary"
                        (click)="requestNomination()"
                        [disabled]="nominationForm.invalid || isLoading"
                    >
                        REQUEST NOMINATION
                        @if (isLoading) {
                            <mat-icon class="ms-2" iconPositionEnd>
                                <mat-spinner diameter="21" />
                            </mat-icon>
                        }
                    </button>
                </div>
            </form>
        </div>
    </div>
</section>
